var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20.4494 20.4507H16.8929V14.8813C16.8929 13.5533 16.8675 11.8447 15.0436 11.8447C13.1903 11.8447 12.9076 13.2913 12.9076 14.7853V20.4507H9.35241V8.998H12.765V10.5627H12.8136C13.2883 9.662 14.4503 8.71267 16.1822 8.71267C19.7834 8.71267 20.4494 11.084 20.4494 14.1687V20.4507ZM5.33918 7.432C4.19522 7.432 3.27391 6.50667 3.27391 5.36733C3.27391 4.22933 4.19522 3.304 5.33918 3.304C6.47782 3.304 7.40246 4.22933 7.40246 5.36733C7.40246 6.50667 6.47782 7.432 5.33918 7.432ZM3.55657 20.4507H7.1198V8.998H3.55657V20.4507ZM22.222 0H1.76995C0.793978 0 0 0.774667 0 1.72933V22.2687C0 23.224 0.793978 24 1.76995 24H22.222C23.2007 24 24 23.224 24 22.2687V1.72933C24 0.774667 23.2007 0 22.222 0Z"}));
}

Linkedin.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
